import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { BrowserSessionStorageService } from '@shared/services/browser-session-storage.service'
import { CHUNK_LOAD_ERROR_RELOAD } from './app.config'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private storage = inject(BrowserSessionStorageService)

  ngOnInit() {
    // If we get here, the app loaded successfully. Clear any pending reload flags.
    if (this.storage.get(CHUNK_LOAD_ERROR_RELOAD)) {
      this.storage.remove(CHUNK_LOAD_ERROR_RELOAD)
    }
  }
}
